import { isColorVisible } from './utils';
import { Tone } from './types';
export const getDefaultTone = () => Tone.default;
export const getToneFromHSLColor = ([h, s, l]) => {
  const tone = getDefaultTone();
  if (isColorVisible([h, s, l]) === false) {
    return tone;
  }
  switch (true) {
    case h >= 0 && h < 15:
      return Tone.lava;
    case h >= 15 && h < 30:
      return Tone.flame;
    case h >= 30 && h < 40:
      return Tone.orange;
    case h >= 40 && h < 65:
      return Tone.acid;
    case h >= 65 && h < 155:
      return Tone.algae;
    case h >= 155 && h < 185:
      return Tone.jellyfish;
    case h >= 185 && h < 225:
      return Tone.blue;
    case h >= 225 && h < 240:
      return Tone.indigo;
    case h >= 240 && h < 280:
      return Tone.purple;
    case h >= 280 && h < 320:
      return Tone.magenta;
    case h >= 320 && h < 350:
      return Tone.pink;
    case h >= 350 && h <= 360:
      return Tone.lava;
    default:
      return tone;
  }
};
//# sourceMappingURL=toneProvider.js.map